import React, { useState } from "react";
import Input from "../Input/Input";
import AuthButton from "../AuthButton/AuthButton";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import Loader from "../Loader/Loader";
import { BaseUrl } from "../../BaseUrl/BaseUrl";
import { toast } from "react-toastify";
import CustomToast from "../CustomToast/CustomToast";
import { Logout, POPUP, refreshToken } from "../../Actions/actions";
import { useDispatch } from "react-redux";

const SecurityProfile = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { loginData } = useSelector((state) => state.userReducer);

  const [errors, setErrors] = useState(false);
  const [loader, setLoader] = useState(false);
  const [formData, setFormData] = useState({
    oldPassword: "",
    newPassword: "",
    confirmNewPassword: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    let errors = {};
    e.preventDefault();

    const { oldPassword, newPassword, confirmNewPassword } = formData;

    try {
      setLoader(true);
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append("Authorization", `Bearer ${loginData?.accessToken}`);

      const raw = JSON.stringify({
        oldPassword: oldPassword,
        newPassword: newPassword,
        confirmPassword: confirmNewPassword,
      });

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      fetch(`${BaseUrl}/api/auth/change-password`, requestOptions)
        .then(async (response) => {
          console.log(response.status, "response.status");
          if (response.status === 401) {
            const rememberMe = JSON.parse(localStorage.getItem("rememberMe")) || false;
            if (rememberMe) {
              refreshToken();
            } else {
              dispatch(Logout(loginData?.accessToken, () => {}));
              localStorage.removeItem("accessToken");
              localStorage.removeItem("refreshToken");
              window.location.href = "/";
            }
          }
          const result = await response.json();
          return result;
        })
        .then((result) => {
          setLoader(false);
          console.log(result);
          if (result.success == true) {
            navigate("/dashboard");
            setFormData({
              oldPassword: "",
              newPassword: "",
              confirmNewPassword: "",
            });
            toast.success(<CustomToast type={"Success"} message={"Password has been changed!"} />, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: false,
              progress: undefined,
              icon: false,
              closeButton: false,
            });
          } else {
            const messages = result?.message?.toLowerCase();
            if (messages?.includes("old password")) {
              errors.oldPassword = result.message;
            } else if (messages?.includes("new password")) {
              errors.newPassword = result.message;
            } else if (messages?.includes("confirm password")) {
              errors.confirmNewPassword = result.message;
            }
            setErrors(errors);
          }
        })
        .catch((error) => {
          setLoader(false);
          console.error(error);
        });
    } catch (error) {
      setLoader(false);
      console.log(error);
    }
  };

  return (
    <div className="flex space-x-8">
      <div className="w-full bg-white p-8 rounded-lg shadow-lg">
        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <Input
              name="oldPassword"
              placeholder="Old Password"
              label="Old Password*"
              password={true}
              value={formData.oldPassword}
              onChange={handleChange}
            />
            {errors.oldPassword && <p className="text-red-500 text-sm">{errors.oldPassword}</p>}
          </div>
          <div>
            <Input
              name="newPassword"
              placeholder="New Password"
              label="New Password*"
              password={true}
              value={formData.newPassword}
              onChange={handleChange}
            />
            {errors.newPassword && <p className="text-red-500 text-sm">{errors.newPassword}</p>}
          </div>
          <div>
            <Input
              name="confirmNewPassword"
              placeholder="Confirm New Password"
              label="Confirm New Password*"
              password={true}
              value={formData.confirmNewPassword}
              onChange={handleChange}
            />
            {errors.confirmNewPassword && <p className="text-red-500 text-sm">{errors.confirmNewPassword}</p>}
          </div>
          <div className="flex justify-end">
            {loader ? (
              <Loader />
            ) : (
              <AuthButton
                type="submit"
                width="20%"
                title={loader ? "Saving..." : "Save Changes"}
                className="px-4 py-2 text-white rounded-md"
                disabled={loader}
              />
            )}
          </div>
        </form>
      </div>
    </div>
  );
};

export default SecurityProfile;
